import { DigitalWalletOwnerInfoResponse } from "@/models/transaction";
import { Box, Grid } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import BlueButtonStyled from "../styled/blue.button.styled";
import ArrowElement from "@/assets/images/ArrowElement.svg";
import { useNavigate } from "react-router-dom";
import { formatDate } from "@/util";
import employeeBreadcrumbStore from "@/stores/employeeBreadcrumbStore";
import StatusActive from "../../assets/icons/status-active.svg";
import StatusInactive from "../../assets/icons/status-inactive.svg";
import { useLocation } from "react-router-dom";

interface IDigitalWalletOwnerInfo {
    info?: DigitalWalletOwnerInfoResponse;
}

const DigitalWalletOwnerInfo: FC<IDigitalWalletOwnerInfo> = ({ info }: IDigitalWalletOwnerInfo) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    const openEmployeePage = (id: number | undefined, employeeName: string) => {
        if (!id) {
            return;
        }
        employeeBreadcrumbStore.update(employeeName);
        navigate({
            pathname: `/employees/${id}/info`,
            search: `?returnUrl=${window.location.pathname}`,
        });
    };

    function goToPreviousPage() {
        const navigateUrl = location.search?.replace("?returnUrl=", "");
        if (navigateUrl) {
            navigate(navigateUrl!);
        } else navigate("/digital-wallet/list/");
    }

    return (
        <>
            <Grid
                sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                }}
            >
                <Grid>
                    {info && (
                        <Grid className="digital-wallet-owner-info-block">
                            <Grid className="digital-wallet-owner-info-sub-block">
                                <Grid>
                                    <Grid className="digital-wallet-owner-info-title">
                                        {t("transaction.TransactionEmployeeName")}:
                                    </Grid>
                                    <Grid className="digital-wallet-owner-info-title">
                                        {t("transaction.TransactionEmployeeNumber")}:
                                    </Grid>
                                </Grid>
                                <Grid>
                                    <Grid className="digital-wallet-owner-info-value">{info.employeeName}</Grid>
                                    <Grid
                                        className="digital-wallet-owner-info-value-link"
                                        onClick={() => openEmployeePage(info.employeeId, info.employeeName)}
                                    >
                                        {info.employeeNumber}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid className="digital-wallet-owner-info-sub-block">
                                <Grid>
                                    <Grid className="digital-wallet-owner-info-title">
                                        {t("general.SearchFilterWalletStatus")}:
                                    </Grid>
                                    <Grid className="digital-wallet-owner-info-title">
                                        {t("digitalWallet.WalletExpiredDate")}:
                                    </Grid>
                                </Grid>
                                <Grid>
                                    <Grid className="digital-wallet-owner-info-value">
                                        {
                                            <Box sx={{ display: "flex" }}>
                                                <Box
                                                    component="img"
                                                    sx={{
                                                        height: "8px",
                                                        width: "8px",
                                                        marginTop: "6px",
                                                    }}
                                                    alt={t("general.Active")}
                                                    src={info.walletStatus === "Active" ? StatusActive : StatusInactive}
                                                />
                                                <Box sx={{ padding: "0 5px" }}>
                                                    {t(`enums.DigitalWalletStatus.${info.walletStatus}`)}
                                                </Box>
                                            </Box>
                                        }
                                    </Grid>
                                    <Grid className="digital-wallet-owner-info-value">
                                        {info.expiredDate && formatDate(info.expiredDate)}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>
                <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "flex-start",
                    }}
                >
                    <BlueButtonStyled sx={{ gap: "7px" }} onClick={() => goToPreviousPage()}>
                        <img src={ArrowElement} alt="ArrowElement" />
                        <div>{t("transaction.BackToListOfWallets")}</div>
                    </BlueButtonStyled>
                </Grid>
            </Grid>
        </>
    );
};

export default DigitalWalletOwnerInfo;
